"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import type { Id } from "@agroproj/backend/convex/_generated/dataModel";
import { useMutation, usePaginatedQuery, useQuery } from "convex/react";
import { PencilIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { ConfirmationDialog } from "@/components/confirmation-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Section } from "@/components/ui/section";
export function AssistantHistory(t0) {
  const $ = _c(45);
  const {
    organizationSlug,
    selected,
    busy,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const enabled = useQuery(api.assistant.history.available, t1);
  const create = useMutation(api.assistant.history.create);
  const update = useMutation(api.assistant.history.update);
  const remove = useMutation(api.assistant.history.remove);
  const [archived, setArchived] = useState(false);
  let t2;
  if ($[1] !== archived || $[2] !== enabled) {
    t2 = enabled ? {
      archived
    } : "skip";
    $[1] = archived;
    $[2] = enabled;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      initialNumItems: 10
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    results,
    status,
    loadMore
  } = usePaginatedQuery(api.assistant.history.list, t2, t3);
  const [show, setShow] = useState(false);
  const [rename, setRename] = useState();
  const [title, setTitle] = useState("");
  if (!enabled) {
    return null;
  }
  const fail = _temp;
  let t4;
  if ($[5] !== create || $[6] !== onSelect || $[7] !== organizationSlug) {
    t4 = () => {
      create({
        organizationSlug
      }).then(onSelect).catch(fail);
    };
    $[5] = create;
    $[6] = onSelect;
    $[7] = organizationSlug;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== busy || $[10] !== t4) {
    t5 = <Button disabled={busy} size="sm" variant="outline" onClick={t4}>Nova conversa salva</Button>;
    $[9] = busy;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onSelect) {
    t6 = () => onSelect();
    $[12] = onSelect;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== busy || $[15] !== t6) {
    t7 = <Button disabled={busy} size="sm" variant="ghost" onClick={t6}>Temporária</Button>;
    $[14] = busy;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== show) {
    t8 = () => setShow(!show);
    $[17] = show;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== show || $[20] !== t8) {
    t9 = <Button size="sm" variant="ghost" aria-expanded={show} onClick={t8}>Histórico</Button>;
    $[19] = show;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = <div className="flex flex-wrap gap-1">{t5}{t7}{t9}</div>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = selected ? "Conversa salva por 30 dias desde a cria\xE7\xE3o. Dados pessoais reconhecidos s\xE3o removidos da c\xF3pia salva; consultas por identificador podem exigir nova entrada." : "Conversa tempor\xE1ria. N\xE3o ser\xE1 salva.";
  let t12;
  if ($[26] !== t11) {
    t12 = <p className="text-muted-foreground">{t11}</p>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== archived || $[29] !== busy || $[30] !== loadMore || $[31] !== onSelect || $[32] !== remove || $[33] !== rename || $[34] !== results || $[35] !== selected || $[36] !== show || $[37] !== status || $[38] !== title || $[39] !== update) {
    t13 = show ? <div className="max-h-52 overflow-y-auto"><Button size="sm" variant="ghost" aria-pressed={archived} onClick={() => setArchived(!archived)}>{archived ? "Ver ativas" : "Ver arquivadas"}</Button>{results.length === 0 ? <p>Nenhuma conversa salva.</p> : results.map(thread => <div key={thread.id} className="border-t py-2"><div className="flex flex-wrap items-center gap-1"><Button className="min-w-0 basis-full justify-start truncate sm:flex-1 sm:basis-auto" disabled={busy} size="sm" variant={selected === thread.id ? "secondary" : "ghost"} onClick={() => onSelect(thread.id)}>{thread.archived ? "Arquivada: " : ""}{thread.title}</Button><Button size="sm" variant="ghost" disabled={busy} onClick={() => {
            update({
              threadId: thread.id,
              archived: !thread.archived
            }).catch(fail);
          }}>{thread.archived ? "Restaurar" : "Arquivar"}</Button><Button aria-label={`Renomear ${thread.title}`} size="icon-sm" variant="ghost" disabled={busy} onClick={() => {
            setRename(thread.id);
            setTitle(thread.title);
          }}><PencilIcon /></Button><Button size="sm" variant="destructive" disabled={busy} onClick={() => {
            remove({
              threadId: thread.id
            }).then(() => {
              if (selected === thread.id) {
                onSelect();
              }
            }).catch(fail);
          }}>Excluir</Button></div>{rename === thread.id ? <form className="grid grid-cols-[1fr_auto] gap-1" onSubmit={event => {
          event.preventDefault();
          update({
            threadId: thread.id,
            title
          }).then(() => setRename(undefined)).catch(fail);
        }}><Input aria-label={"T\xEDtulo da conversa"} maxLength={100} value={title} onChange={e => setTitle(e.target.value)} /><Button type="submit">Salvar</Button></form> : null}</div>)}{status === "CanLoadMore" ? <Button size="sm" variant="ghost" onClick={() => loadMore(10)}>Mais conversas</Button> : null}</div> : null;
    $[28] = archived;
    $[29] = busy;
    $[30] = loadMore;
    $[31] = onSelect;
    $[32] = remove;
    $[33] = rename;
    $[34] = results;
    $[35] = selected;
    $[36] = show;
    $[37] = status;
    $[38] = title;
    $[39] = update;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t10 || $[42] !== t12 || $[43] !== t13) {
    t14 = <div className="space-y-2 border-b px-4 py-2 text-xs/relaxed">{t10}{t12}{t13}</div>;
    $[41] = t10;
    $[42] = t12;
    $[43] = t13;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  return t14;
}

/** Always available from account settings, even when assistant/history flags are off. */
function _temp() {
  return toast.error("N\xE3o foi poss\xEDvel atualizar o hist\xF3rico.");
}
export function AssistantHistoryPrivacy() {
  const {
    results,
    status,
    loadMore
  } = usePaginatedQuery(api.assistant.history.privacyList, {}, {
    initialNumItems: 20
  });
  const remove = useMutation(api.assistant.history.remove);
  const removeAll = useMutation(api.assistant.history.removeAll);
  const [deleting, setDeleting] = useState(false);
  const [confirmRemoveAll, setConfirmRemoveAll] = useState(false);
  return <Section title="Privacidade das conversas">
      <p>
        Conversas salvas são privadas para sua conta e expiram após 30 dias. A exclusão remove o
        acesso imediatamente; a limpeza ocorre em até 24 horas. Operadores do Convex e backups
        retidos podem ter acesso residual.
      </p>
      <p>Esta lista mostra apenas datas, sem títulos personalizados ou conteúdo.</p>

      <Button className="self-start" size="sm" variant="destructive" disabled={deleting || results.length === 0} onClick={() => setConfirmRemoveAll(true)}>
        Excluir todas as conversas
      </Button>
      <ConfirmationDialog confirmText="Excluir" description="Todas as conversas salvas serão excluídas. Esta ação não pode ser desfeita." onConfirm={async () => {
      setDeleting(true);
      try {
        let more = true;
        while (more) more = (await removeAll({})).more;
        toast.success("Conversas excluídas.");
      } catch {
        toast.error("Não foi possível excluir as conversas.");
      } finally {
        setDeleting(false);
      }
    }} onOpenChange={setConfirmRemoveAll} open={confirmRemoveAll} pendingText="Excluindo..." title="Excluir todas as conversas" variant="destructive" />
      {results.map(thread => <div className="flex items-center justify-between gap-2" key={thread.id}>
          <span>{thread.title}</span>
          <Button size="sm" variant="destructive" onClick={() => {
        void remove({
          threadId: thread.id
        }).catch(() => toast.error("Não foi possível excluir."));
      }}>
            Excluir
          </Button>
        </div>)}
      {status === "CanLoadMore" ? <Button size="sm" variant="ghost" onClick={() => loadMore(20)}>
          Mais conversas
        </Button> : null}
    </Section>;
}